import "../style/editstudentpage.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../style/dashboardstudent.css";
import DateInput from "../components/DateInput";

const DashboardStudent = () => {
  const navigate = useNavigate();
  const [errorMe, setErrorMe] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [getEmail, setGetEmail] = useState("");

  const [studentId, setStudentId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dob, setDob] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postal, setPostal] = useState("");
  const [sp, setSp] = useState("");
  const [church, setChurch] = useState("");
  const [otherChurch, setOtherChurch] = useState("");
  const [classType, setClassType] = useState("");
  const [dj, setDj] = useState("");
  const [role, setRole] = useState("");
  const [programs, setPrograms] = useState("");
  const [classes, setClasses] = useState({
    className: [],
  });
  const [tshirtSize, setTshirtSize] = useState("");
  const [joined, setJoined] = useState("");
  const [year, setYear] = useState("");
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [batchJoined, setBtachJoined] = useState("");

  const classOrder = [
    "OT",
    "NT",
    "BD",
    "BLC",
    "BCMF",
    "HH",
    "CBH",
    "CBD",
    "BWG",
    "MMM",
  ];

  const class1Year = [
    { name: "OT", status: "completed" },
    { name: "NT", status: "completed" },
    { name: "BD", status: "completed" },
    { name: "BLC", status: "completed" },
    { name: "BCMF", status: "completed" },
    { name: "MASTERCLASS", status: "completed" },
    { name: "HH", status: "completed" },
    { name: "CBH", status: "completed" },
    { name: "CBD", status: "completed" },
    { name: "BWG", status: "completed" },
    { name: "MMM", status: "completed" },
    { name: "CONFERENCE", status: "completed" },
  ];

  const handleCheckboxChange = (value) => {
    setClasses((prev) => {
      const exists = prev.className.find((c) => c.name === value);

      let updated;

      if (exists) {
        // jika status completed → tidak boleh dihapus
        // if (exists.status === "completed") {
        //   return prev;
        // }

        // jika requested → boleh dihapus
        updated = prev.className.filter((c) => c.name !== value);
      } else {
        // tambahkan kelas baru dengan status requested
        updated = [...prev.className, { name: value, status: "completed" }];
      }

      // sorting sesuai urutan kelas
      updated.sort(
        (a, b) => classOrder.indexOf(a.name) - classOrder.indexOf(b.name),
      );

      return {
        // ...prev,
        className: updated,
      };
    });
    // console.log(classes);
  };

  const handleCancel = async () => {
    const result = await Swal.fire({
      html: `
    Unsaved changes<br/>
    Do you want to cancel?
  `,
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      navigate("/profilepage");
    } else if (result.isDismissed) {
    }
  };

  const handleSubmit = async () => {
    const result = await Swal.fire({
      text: "Do you want to save changes ?",
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      let finalDj = dj;
      let finalRole = role;
      let finalClasses = classes;
      let finalYear = year;
      let finalq1 = q1;
      let finalq2 = q2;
      let finalq3 = q3;
      let finalq4 = q4;
      let finalq5 = q5;

      if (church !== "IFGF Bandung") {
        finalDj = "";
        finalRole = "";
      }

      if (programs === "1 Year Program") {
        finalClasses = {
          className: class1Year,
        };
      }

      try {
        const payload = {
          studentId: studentId,
          name: fullName,
          email: email,
          phoneNumber: phone,
          dateOfBirth: dob,
          address: address,
          city: city,
          province: province,
          postalCode: postal,
          studentPackage: sp,
          localChurch: church === "Others" ? otherChurch : church,
          lastDj: finalDj,
          role: finalRole,
          classType: classType,
          programs: programs,
          tshirtSize: tshirtSize,
          classes: finalClasses,
          joinedCEA: joined,
          year: finalYear,
          question1: finalq1,
          question2: finalq2,
          question3: finalq3,
          question4: finalq4,
          question5: finalq5,
          batchJoined: batchJoined,
        };

        await axios.patch(`/studentdashboard/${getEmail}`, payload);
        setIsLoading(false);

        Swal.fire({
          text: "Data Submitted.",
          icon: "success",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });
      } catch (error) {
        setIsLoading(false);
        Swal.fire({
          text: `${error.response.data.msg}`,
          icon: "error",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });
      }

      const result2 = await Swal.fire({
        text: "Data Saved!",
        icon: "success",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#0004ff",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });

      if (result2.isConfirmed) {
        window.location.reload();
      }
    } else if (result.isDismissed) {
    }
  };

  const getMe = async () => {
    try {
      const response = await axios.get("/mestudent");
      setGetEmail(response.data.email);
    } catch (error) {
      setErrorMe(true);
    } finally {
      setIsLoading(false);
    }
  };

  const getProfile = async () => {
    try {
      // const response = await axios.get(`/verifydata/${getEmail}`);
      const response = await axios.get(`/verifydatadashboard/${getEmail}`);
      console.log(response);
      setStudentId(response.data.studentId);
      setFullName(response.data.name);
      setEmail(response.data.email);
      setPhone(response.data.phoneNumber);
      setDob(response.data.dateOfBirth);
      setAddress(response.data.address);
      setCity(response.data.city);
      setProvince(response.data.province);
      setPostal(response.data.postalCode);
      setSp(response.data.studentPackage);
      if (response.data.localChurch !== "IFGF Bandung") {
        setChurch("Others");
        setOtherChurch(response.data.localChurch);
      } else {
        setChurch(response.data.localChurch);
        setRole(response.data.role);
        setDj(response.data.lastDj);
      }
      setClassType(response.data.classType);
      setPrograms(response.data.program);
      setClasses(JSON.parse(response.data.classList));
      setTshirtSize(response.data.tshirtSize);
      setJoined("Yes");
      setYear(response.data.yearJoined);
      setQ1(response.data.question1);
      setQ2(response.data.question2);
      setQ3(response.data.question3);
      setQ4(response.data.question4);
      setQ5(response.data.question5);
    } catch (error) {
      // setErrorMe(true);
      const response = await axios.get(`/verifydatadashboard/${getEmail}`);
      const result = await Swal.fire({
        text: `${response.data.msg}`,
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });
      if (result.isConfirmed) {
        const response = await axios.delete("/logoutstudent");
        navigate("/loginstudent")
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMe();
  }, []);

  useEffect(() => {
    if (getEmail) {
      getProfile();
    }
  }, [getEmail]);

  useEffect(() => {
    if (errorMe) {
      Swal.fire({
        title: "Session Expired",
        text: "Please login to your account !",
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });

      navigate("/loginstudent");
    }
  }, [errorMe, navigate]);

  // console.log(getEmail);

  return (
    <div className="custom-con-dashboard-student position-relative">
      <div className="custom-con-content-editdata-student">
        <div
          className="custom-con-form-editdata-student"
          // style={{ maxHeight: "87vh", overflowY: "auto" }}
        >
          <p className="custom-title-text-editpage-student text-center">
            {`Edit Profile`}
          </p>
          <form>
            <div className="custom-margin-form">
              <label className="form-label">Full Name</label>
              <input
                type="text"
                className="form-control custom-con-input"
                placeholder="Full Name"
                value={fullName || ""}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
            <div className="custom-margin-form">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control custom-con-input"
                placeholder="example@gmail.com"
                value={email || ""}
                onChange={(e) => setEmail(e.target.value)}
                disabled
              />
            </div>
            <div className="custom-margin-form">
              <label className="form-label">Whatsapp Number</label>
              <input
                type="text"
                className="form-control custom-con-input"
                placeholder="6287xxxxxxxxx"
                value={phone || ""}
                onChange={(e) => {
                  setPhone(e.target.value.replace(/\D/g, ""));
                }}
              />
            </div>
            <div className="custom-margin-form">
              <label className="form-label">Date of Birth</label>
              <DateInput
                className="form-control custom-con-input"
                value={dob || ""}
                onChange={(e) => setDob(e.target.value)}
              />
            </div>
            <div className="custom-margin-form">
              <label className="form-label">Address (Indonesia Address)</label>
              <textarea
                rows="2"
                className="form-control form-control-textarea"
                placeholder="Insert your address"
                value={address || ""}
                onChange={(e) => setAddress(e.target.value)}
              ></textarea>
            </div>
            <div className="custom-margin-form">
              <label className="form-label">City</label>
              <input
                type="text"
                className="form-control custom-con-input"
                placeholder="City"
                value={city || ""}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <div className="row align-items-center">
              <div className="col-6">
                <div className="custom-margin-form">
                  <label className="form-label">Province</label>
                  <input
                    type="text"
                    className="form-control custom-con-input"
                    placeholder="Province"
                    value={province || ""}
                    onChange={(e) => setProvince(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="custom-margin-form">
                  <label className="form-label">Postal Code</label>
                  <input
                    type="text"
                    className="form-control custom-con-input"
                    placeholder="Postal Code"
                    value={postal || ""}
                    onChange={(e) => {
                      setPostal(e.target.value.replace(/\D/g, ""));
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column mt-4">
              <label className="form-label">Student Package</label>
              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="sp"
                  value="The House Convention Hall"
                  checked={sp === "The House Convention Hall"}
                  onChange={(e) => setSp(e.target.value)}
                />
                &nbsp;The House Convention Hall
              </label>

              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="sp"
                  value="Shipping"
                  checked={sp === "Shipping"}
                  onChange={(e) => setSp(e.target.value)}
                />
                &nbsp;Shipping (only for student outside Bandung)
              </label>
            </div>

            <div className="custom-margin-form mt-4">
              <label className="form-label ">Church</label>
              <select
                className="form-select custom-con-input"
                value={church || ""}
                onChange={(e) => setChurch(e.target.value)}
              >
                <option defaultValue="">Select Local Church</option>
                <option value="IFGF Bandung">IFGF Bandung</option>
                <option value="Others">Others</option>
              </select>
            </div>
            {church === "IFGF Bandung" ? (
              <>
                <div className="custom-margin-form mt-4">
                  <label className="form-label ">Last DJ Class</label>
                  <select
                    className="form-select custom-con-input"
                    value={dj || ""}
                    onChange={(e) => setDj(e.target.value)}
                  >
                    <option defaultValue="">Select DJ Class</option>
                    <option value="Come">Come</option>
                    <option value="Grow">Grow</option>
                    <option value="Serve">Serve</option>
                    <option value="Lead">Lead</option>
                    <option value="None">None</option>
                  </select>
                </div>
                <div className="custom-margin-form mt-4">
                  <label className="form-label ">Role</label>
                  <select
                    className="form-select custom-con-input"
                    value={role || ""}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option defaultValue="">Select Role</option>
                    <option value="HITS/MTh Student">HITS/Mth Student</option>
                    <option value="Pastoral">Pastoral</option>
                    <option value="Staff">Staff</option>
                    <option value="Coach">Coach</option>
                    <option value="Care Group Leader (CGL)">
                      Care Group Leader (CGL)
                    </option>
                    <option value="Core Team Leader (CTL)">
                      Core Team Leader (CTL)
                    </option>
                    <option value="Attendees (IFGF BDG)">
                      Attendees (IFGF BDG)
                    </option>
                  </select>
                </div>{" "}
              </>
            ) : church === "Others" ? (
              <>
                <div className="custom-margin-form">
                  <label className="form-label">Local Church</label>
                  <input
                    type="text"
                    className="form-control custom-con-input"
                    placeholder="Input Local Church"
                    value={otherChurch || ""}
                    onChange={(e) => setOtherChurch(e.target.value)}
                  />
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="d-flex flex-column mt-5">
              <label className="form-label">Online / Onsite</label>
              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="classType"
                  value="Online"
                  checked={classType === "Online"}
                  onChange={(e) => setClassType(e.target.value)}
                />
                &nbsp;Online
              </label>

              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="classType"
                  value="Onsite"
                  checked={classType === "Onsite"}
                  onChange={(e) => setClassType(e.target.value)}
                />
                &nbsp;Onsite
              </label>
            </div>

            <div className="custom-margin-form mt-4">
              <label className="form-label ">Programs</label>
              <select
                className="form-select custom-con-input"
                value={programs || ""}
                onChange={(e) => setPrograms(e.target.value)}
                disabled
              >
                <option value="">Select program</option>
                <option value="1 Year Program">1 Year Program</option>
                <option value="1 Month Course">1 Month Course</option>
              </select>
            </div>

            {programs === "1 Year Program" ? (
              <>
                <div className="custom-margin-form mt-4">
                  <label className="form-label">Tshirt Size</label>
                  <select
                    className="form-select custom-con-input"
                    value={tshirtSize || ""}
                    onChange={(e) => setTshirtSize(e.target.value)}
                    disabled
                  >
                    <option defaultValue="">Select Size</option>
                    <option value="s">
                      S (Lebar Dada = 52cm | Panjang Baju 67cm)
                    </option>
                    <option value="m">
                      M (Lebar Dada = 55cm | Panjang Baju 68cm)
                    </option>
                    <option value="l">
                      L (Lebar Dada = 58cm | Panjang Baju 72cm)
                    </option>
                    <option value="xl">
                      XL (Lebar Dada = 61cm | Panjang Baju 76cm)
                    </option>
                    <option value="xxl">
                      XXL (Lebar Dada = 63cm | Panjang Baju 80cm)
                    </option>
                  </select>
                </div>
              </>
            ) : programs === "1 Month Course" ? (
              <>
                <div className="form-check">
                  <label className="form-label">Joined class</label>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="OT"
                      checked={classes.className.some((c) => c.name === "OT")}
                      onChange={() => handleCheckboxChange("OT")}
                      disabled
                    />
                    <label className="form-check-label">
                      Old Testament Survey | 8-12 Sept
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="NT"
                      checked={classes.className.some((c) => c.name === "NT")}
                      onChange={() => handleCheckboxChange("NT")}
                      disabled
                    />
                    <label className="form-check-label">
                      New Testament Survey | 29 Sept - 3 Oct
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="BD"
                      checked={classes.className.some((c) => c.name === "BD")}
                      onChange={() => handleCheckboxChange("BD")}
                      disabled
                    />
                    <label className="form-check-label">
                      Basic Doctrine | 3-7 Nov
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="BLC"
                      checked={classes.className.some((c) => c.name === "BLC")}
                      onChange={() => handleCheckboxChange("BLC")}
                      disabled
                    />
                    <label className="form-check-label">
                      Biblical Leadership and Communication | 1-5 Dec
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="BCMF"
                      checked={classes.className.some((c) => c.name === "BCMF")}
                      onChange={() => handleCheckboxChange("BCMF")}
                      disabled
                    />
                    <label className="form-check-label">
                      Biblical Counseling + Marriage and Family | 12-16 Jan
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="HH"
                      checked={classes.className.some((c) => c.name === "HH")}
                      onChange={() => handleCheckboxChange("HH")}
                      disabled
                    />
                    <label className="form-check-label">
                      Hermeneutic and Homiletic | 25-27 Mar + 30-31 Mar
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CBH"
                      checked={classes.className.some((c) => c.name === "CBH")}
                      onChange={() => handleCheckboxChange("CBH")}
                      disabled
                    />
                    <label className="form-check-label">
                      Church in The Bible History | 13-17 Apr
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CBD"
                      checked={classes.className.some((c) => c.name === "CBD")}
                      onChange={() => handleCheckboxChange("CBD")}
                      disabled
                    />
                    <label className="form-check-label">
                      Covenants and Biblical Discipleship | 4-8 May
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="BWG"
                      checked={classes.className.some((c) => c.name === "BWG")}
                      onChange={() => handleCheckboxChange("BWG")}
                      disabled
                    />
                    <label className="form-check-label">
                      Biblical Worship and Gatherings | 1-5 June
                    </label>
                  </div>

                  <div className="custom-text-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MMM"
                      checked={classes.className.some((c) => c.name === "MMM")}
                      onChange={() => handleCheckboxChange("MMM")}
                      disabled
                    />
                    <label className="form-check-label">
                      Mission and Marketplace Ministry | 20-24 July
                    </label>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="d-flex flex-column mt-5">
              <label className="form-label">
                Have you ever joined Cutting Edge Academy before?
              </label>
              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="joined"
                  value="Yes"
                  checked={joined === "Yes"}
                  onChange={(e) => setJoined(e.target.value)}
                />
                &nbsp;Yes
              </label>

              <label className="custom-radio-space">
                <input
                  type="radio"
                  name="joined"
                  value="No"
                  checked={joined === "No"}
                  onChange={(e) => setJoined(e.target.value)}
                />
                &nbsp;No
              </label>
            </div>

            <div className="custom-margin-form mt-4">
              <label className="form-label">
                Bagaimana kisah perjalanan kekristenan Anda, ketika Anda
                mengalami lahir baru hingga saat ini?
              </label>
              <textarea
                rows="2"
                className="form-control form-control-textarea"
                value={q1 || ""}
                onChange={(e) => setQ1(e.target.value)}
                // placeholder="Insert your answer"
              ></textarea>
            </div>
            <div className="custom-margin-form">
              <label className="form-label">
                Apakah Anda sudah mengalami baptisan?
              </label>
              <textarea
                rows="1"
                className="form-control form-control-textarea"
                value={q2 || ""}
                onChange={(e) => setQ2(e.target.value)}
                // placeholder="Insert your answer"
              ></textarea>
            </div>
            <div className="custom-margin-form">
              <label className="form-label">
                Ceritakan beberapa pengalaman pelayanan Anda dan buah dari
                pelayanan-pelayanan tersebut.
              </label>
              <textarea
                rows="2"
                className="form-control form-control-textarea"
                value={q3 || ""}
                onChange={(e) => setQ3(e.target.value)}
                // placeholder="Insert your answer"
              ></textarea>
            </div>
            <div className="custom-margin-form">
              <label className="form-label">
                Apa rencana dan langkah Anda selanjutnya setelah mengikuti
                Cutting Edge Academy?
              </label>
              <textarea
                rows="2"
                className="form-control form-control-textarea"
                value={q4 || ""}
                onChange={(e) => setQ4(e.target.value)}
                // placeholder="Insert your answer"
              ></textarea>
            </div>
            <div className="custom-margin-form">
              <label className="form-label">
                Bagaimana kisah perjalanan kekristenan Anda, ketika Anda
                mengalami lahir baru hingga saat ini?
              </label>
              <textarea
                rows="2"
                className="form-control form-control-textarea"
                value={q5 || ""}
                onChange={(e) => setQ5(e.target.value)}
                // placeholder="Insert your answer"
              ></textarea>
            </div>
          </form>
          <button
            className="custom-btn-cancel-editdata-student position-relative top-0 end-0"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="custom-btn-submit-editdata-student position-relative top-0 end-0"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
        {/* <div className="custom-con-btn-editdata-student text-center">
          <button className="custom-btn-submit-editdata-student" onClick={handleSubmit}>
            Submit
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default DashboardStudent;
